import { Component, OnDestroy } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-spr-base',
  template: ''
})
export class ParrotBaseComponent implements OnDestroy {
  public isMobile = false;
  public isDesktop = false;
  public subscription = new Subscription();
  constructor(public deviceService: DeviceDetectorService) {
    this.isMobile = this.deviceService.isMobile();
    this.isDesktop = this.deviceService.isDesktop() || this.deviceService.isTablet();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
